import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Table from './Table.jsx'
//import _ from 'lodash'

class RequestsComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.requests.misc && !this.props.requests.misc.dataIsLoading) {
      return <div><Table requests={this.props.requests}></Table></div>
    }
    return <div>You do not have any requests!</div>
  }
}

RequestsComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  requests: PropTypes.object.isRequired,
}

export default RequestsComponent
